import { defineComponent as e, inject as n, createElementBlock as f, openBlock as c, createVNode as a, unref as t, withCtx as m, renderSlot as p } from "vue";
import "./highrise52.mjs";
import { COMPONENT_NAME as _ } from "./highrise174.mjs";
import u from "./highrise91.mjs";
const d = { class: "hr-section-footer-item" }, l = e({
  name: _.SECTION_FOOTER_ITEM,
  inheritAttrs: !1
}), O = /* @__PURE__ */ e({
  ...l,
  props: {
    justify: {
      type: String,
      default: "end"
    }
  },
  setup(o) {
    const r = o, s = n("hr-section-footer-gap", "sm");
    return (i, h) => (c(), f("div", d, [
      a(t(u), {
        size: t(s),
        justify: r.justify,
        "wrap-item": ""
      }, {
        default: m(() => [
          p(i.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["size", "justify"])
    ]));
  }
});
export {
  O as default
};
